import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-numberone",
  "use": "icon-th-numberone-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-numberone\">\n<path d=\"M18 6.00007V26.0001C18 26.2653 17.8947 26.5196 17.7071 26.7072C17.5196 26.8947 17.2652 27.0001 17 27.0001C16.7348 27.0001 16.4805 26.8947 16.2929 26.7072C16.1054 26.5196 16 26.2653 16 26.0001V7.76632L12.515 9.85757C12.2876 9.99415 12.0152 10.0348 11.7578 9.97057C11.5004 9.90634 11.2791 9.74249 11.1425 9.51507C11.0059 9.28764 10.9653 9.01528 11.0295 8.75788C11.0938 8.50049 11.2576 8.27915 11.485 8.14257L16.485 5.14257C16.6368 5.05139 16.81 5.00214 16.987 4.99984C17.1641 4.99754 17.3385 5.04228 17.4926 5.12949C17.6467 5.21669 17.7748 5.34324 17.864 5.49619C17.9531 5.64915 18.0001 5.82303 18 6.00007Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-numberone.svg
// module id = 24dd
// module chunks = 83